import React from "react";
import { Flex, Image } from "theme-ui";
import { CustomLink } from "../atoms";
import facebook from "../../../static/logos/facebook.png"
import twitter from "../../../static/logos/twitter.png"
import linkedIn from "../../../static/logos/linked-in.png"
import instagram from "../../../static/logos/instagram.png"
import youtube from "../../../static/logos/youtube.png"

const socialhandles = {
	"Ind": [
		{
			link: "https://www.facebook.com/greytip/",
    	image: facebook,
    	name: "Facebook",
		},
		{
			link: "https://twitter.com/greythr2",
    	image: twitter,
    	name: "Twitter",
		},
		{
			link: "https://www.linkedin.com/company/600275/admin/feed/posts/",
    	image: linkedIn,
    	name: "LinkedIn",
		},
		{
			link: "https://www.instagram.com/greythrofficial/",
    	image: instagram,
    	name: "Instagram",
		},
		{
			link: "https://www.youtube.com/@GreytipIn",
    	image: youtube,
    	name: "YouTube",
		}
	],
	"ME": [
		{
			link: "https://www.facebook.com/greytip/",
    	image: facebook,
    	name: "Facebook",
		},
		{
			link: "https://twitter.com/greythr2",
    	image: twitter,
    	name: "Twitter",
		},
		{
			link: "https://www.linkedin.com/company/80753639/admin/feed/posts/",
    	image: linkedIn,
    	name: "LinkedIn",
		},
		{
			link: "https://www.instagram.com/greythrofficial/",
    	image: instagram,
    	name: "Instagram",
		},
		{
			link: "https://www.youtube.com/@GreytipIn",
    	image: youtube,
    	name: "YouTube",
		}
	]
}

const SocialHandles = ({region}) => {
	const { Ind, ME } = socialhandles;
	const list = region === "ME" || region === "middle-east" ? ME : Ind;
	return (
		<Flex sx={{ gap: "0.813rem"}}>
			{list?.map(({link, image, name}) => (
				<CustomLink url={link} key={name}>
					<Image
						src={image}
						alt={name}
						width={40}
						height={40}
					/>
				</CustomLink>
			))}
		</Flex>
	)
}

export default SocialHandles;
